import { toast } from 'react-toastify';
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import "./adminDashboard.css";
import { clearData } from '../../../utils/localStorage';
import SideBar from "../../commanComponents/sidebar/sidebar";
import { sidebarNavItems, ROUTES } from "../../../constant";
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import SkeletonLoading from '../../commanComponents/skeletonLoading/skeletonLoading';
import { getSchoolAdminDashboardService, getSessionListService } from "../../../modules/services";


const AdminDashbaord = () => { 
    const [dataList, setDataList] = useState([]);
    const [sessionData, setSessionData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const FilterSchema = z.object({
        //session_filter
        session_filter: z.string(),
        //school_filter
        school_filter: z.string(),
        //class_filter
        class_filter: z.string(),
        //section_filter
        section_filter: z.string(),
    });
    const {getValues: filterGetValues, setValue: filterSetValue } = useForm({
        resolver: zodResolver(FilterSchema)
    });

    const renderDropdownListData = (listData, label, value, id) => {
        return(listData.map(data => ({label: data[label], value: data[value], id: data[id]})))
    }
    
    const getDashboardData = () => {
        const sessionFilterData = filterGetValues("session_filter");
        setIsLoading(true);
        (async () => {
            const responseData = await getSchoolAdminDashboardService({
                remove_pagination: true,
                session: sessionFilterData
            });
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setDataList(responseData.data);

                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
                toast.error(responseData.data.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            else {
                clearData();
                toast.error(responseData.data.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                });
                navigate(ROUTES.LOGIN);
            }
        })();
    };

    const getSessionData = () => { 
        setIsLoading(true);
        (async () => {
            const responseData = await getSessionListService({pagination: false});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                
                const sessionList = renderDropdownListData(responseData.data, "session_name", "id", "id");
                setSessionData(sessionList);
                filterSetValue("session_filter", sessionList[0]?.value);
                getDashboardData();
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }

    useEffect(() => {
        getSessionData();
    }, []);

    const renderModuleList = (moduleList) => {
        if (!moduleList?.length) return <label className='profile-value'>-</label>;

        return moduleList.map((module) => (
            <label className='profile-value' key={module.id || module.module_value}>
                {module.module_name}
                <br />
            </label>
        ));
    };


    return (
        <div className='admin-dashboard-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.dashboard} />
            <div className='admin-dashboard-side-container'>
                <TopNavigation activeItem={sidebarNavItems.dashboard} />
                <div className="admin-dashboard-main">
                    <div className="row">
                        <div className="col">
                            <div className="row">
                                <div className="col">
                                    <div className='admin-dashboard-tile-container'>
                                        <h4 className="admin-dashboard-main-contain-heading">Enrolled Students</h4>
                                        <hr className="admin-dashboard-border" />
                                        <label className="admin-dashboard-main-contain-count">{ isLoading ? <SkeletonLoading customStyle={{width: "100px", height: "80px"}} />: dataList.enrolled_student_count}</label>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className='admin-dashboard-tile-container'>
                                        <h4 className="admin-dashboard-main-contain-heading">Classes Taken</h4>
                                        <hr className="admin-dashboard-border" />
                                        <label className="admin-dashboard-main-contain-count">{ isLoading ? <SkeletonLoading customStyle={{width: "100px", height: "80px"}} />: dataList.classes_taken}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className='admin-dashboard-tile-container'>
                                        <h4 className="admin-dashboard-main-contain-heading">Weekly Present</h4>
                                        <hr className="admin-dashboard-border" />
                                        <label className="admin-dashboard-main-contain-count">{ isLoading ? <SkeletonLoading customStyle={{width: "100px", height: "80px"}} />: dataList.weekly_present_count}</label>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className='admin-dashboard-tile-container'>
                                        <h4 className="admin-dashboard-main-contain-heading">Weekly Absent</h4>
                                        <hr className="admin-dashboard-border" />
                                        <label className="admin-dashboard-main-contain-count">{ isLoading ? <SkeletonLoading customStyle={{width: "100px", height: "80px"}} />: dataList.weekly_absent_count}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className='admin-dashboard-tile-container'>
                                        <h4 className="admin-dashboard-main-contain-heading">Monthly Present (%)</h4>
                                        <hr className="admin-dashboard-border" />
                                        <label className="admin-dashboard-main-contain-count">{ isLoading ? <SkeletonLoading customStyle={{width: "100px", height: "50px"}} />: dataList.present_percentage}</label>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className='admin-dashboard-tile-container'>
                                        <h4 className="admin-dashboard-main-contain-heading">Monthly Absent (%)</h4>
                                        <hr className="admin-dashboard-border" />
                                        <label className="admin-dashboard-main-contain-count">{ isLoading ? <SkeletonLoading customStyle={{width: "100px", height: "50px"}} />: dataList.absent_percentage}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <div className='admin-dashboard-info-container'>
                                <h4 className="admin-dashboard-main-contain-heading">Session Summary</h4>
                                <hr className="admin-dashboard-border" />
                                <div className='row'>
                                    <div className='col-sm-4'>
                                        <label className='profile-label'>Session Name</label>
                                    </div>
                                    <div className='col'>
                                        <label className='profile-value'>{ isLoading ? <SkeletonLoading customStyle={{width: "100px"}} />: dataList.session_name}</label>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm-4'>
                                        <label className='profile-label'>Mentor Name</label>
                                    </div>
                                    <div className='col'>
                                        <label className='profile-value'>{ isLoading ? <SkeletonLoading customStyle={{width: "150px"}} />: dataList.mentor_name}</label>
                                    </div>
                                </div>
                            </div>
                            <div className='admin-dashboard-info-container'>
                                <h4 className="admin-dashboard-main-contain-heading">Module Summary</h4>
                                <hr className="admin-dashboard-border" />
                                <label className='profile-label'>Current Module</label><br/>
                                {isLoading ? <SkeletonLoading customStyle={{width: "180px"}} /> : renderModuleList(dataList.teaching_modules?.active_modules)}
                                <br/>
                                <label className='profile-label'>Past Module</label><br/>
                                {isLoading ? <SkeletonLoading customStyle={{width: "180px"}} /> : renderModuleList(dataList.teaching_modules?.past_modules)}
                                <br/>
                                <label className='profile-label'>Upcoming Module</label><br/>
                                {isLoading ? <SkeletonLoading customStyle={{width: "180px"}} /> : renderModuleList(dataList.teaching_modules?.future_modules)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default AdminDashbaord;
